import AOS from 'aos';
import Splide from '@splidejs/splide';
import { unitlessBreakpoints } from './breakpoints';

const selectors = {
  mainCarousel: '[data-splide-carousel]',
  currentCounter: '[data-testimonials-current]',
};

const initCarousel = (el, options = {}, replaceOptions = false) => {
  const carousel = el.querySelector(selectors.mainCarousel);
  let carouselOptions = {};

  const currentCounter = el.querySelector(selectors.currentCounter);

  const updateCounter = splide => {
    if (currentCounter && splide) {
      const currentSlide = splide.index + 1;
      currentCounter.textContent = currentSlide;
    }
  };

  if (carousel) {
    carouselOptions = {
      perPage: 2,
      perMove: 1,
      gap: '1rem',
      mediaQuery: 'min',
      breakpoints: {
        [unitlessBreakpoints.md]: {
          perPage: 3,
        },
        [unitlessBreakpoints.lg]: {
          perPage: 4,
        },
      },
      ...options,
    };

    if (replaceOptions) {
      carouselOptions = options;
    }

    const splide = new Splide(carousel, carouselOptions).mount();
    updateCounter(splide);

    if (splide.length <= splide.options.perPage) {
      splide.options = {
        arrows: false,
      };
    }

    splide.on('hidden', () => {
      if (splide.length > splide.options.perPage && splide.options.arrows) {
        splide.options = {
          arrows: true,
        };
      }
    });
    splide.on('visible', () => {
      if (splide.length <= splide.options.perPage) {
        splide.options = {
          arrows: false,
        };
      }
    });

    splide.on(['moved', 'resize'], () => {
      updateCounter(splide);
    });

    AOS.refresh();
    return splide;
  }
};

export default initCarousel;
